import { EmployeeNodeModel } from "../../../models";

const SNAPSHOT_KEY = "overtime-schedule-home-snapshot";
const RESTORE_PENDING_KEY = "overtime-schedule-restore-pending";

export interface OvertimeHomeSnapshot {
  selectedEmployees: EmployeeNodeModel[];
  employeesToShowTable: EmployeeNodeModel[];
  employeesSelectedBackup: EmployeeNodeModel[];
  startDateScheduling: string;
  endDateScheduling: string;
  showEmployeesTable: boolean;
  isCollapseTree: boolean;
  selectedNodeIds: (string | number)[];
}

export interface OvertimeHomeRestoreSetters {
  setSelectedEmployees: (state: EmployeeNodeModel[]) => void;
  setEmployeesSelectedBackup: (state: EmployeeNodeModel[]) => void;
  setEmployeesToShowTable: (state: EmployeeNodeModel[]) => void;
  setStartDateScheduling: (state: string) => void;
  setEndDateScheduling: (state: string) => void;
  setShowEmployeesTable: (state: boolean) => void;
  setEmployeesFromTemplate: (state: EmployeeNodeModel[]) => void;
  setIsCollapseTree: (state: boolean) => void;
}

export const reconcileNodesWithTree = (
  tree: EmployeeNodeModel[],
  nodeIds: (string | number)[],
): EmployeeNodeModel[] => {
  const idSet = new Set(nodeIds.map(String));
  return tree.filter((node) => idSet.has(String(node.id)));
};

export const saveOvertimeHomeSnapshot = (snapshot: OvertimeHomeSnapshot) => {
  sessionStorage.setItem(SNAPSHOT_KEY, JSON.stringify(snapshot));
};

export const markOvertimeHomeRestorePending = () => {
  sessionStorage.setItem(RESTORE_PENDING_KEY, "true");
};

export const restoreOvertimeHomeStateIfPending = (
  setters: OvertimeHomeRestoreSetters,
): OvertimeHomeSnapshot | null => {
  const isPending = sessionStorage.getItem(RESTORE_PENDING_KEY) === "true";
  if (!isPending) return null;

  const raw = sessionStorage.getItem(SNAPSHOT_KEY);
  if (!raw) {
    sessionStorage.removeItem(RESTORE_PENDING_KEY);
    return null;
  }

  const snapshot: OvertimeHomeSnapshot = JSON.parse(raw);

  setters.setSelectedEmployees(snapshot.selectedEmployees);
  setters.setEmployeesSelectedBackup(snapshot.employeesSelectedBackup);
  setters.setEmployeesToShowTable(snapshot.employeesToShowTable);
  setters.setStartDateScheduling(snapshot.startDateScheduling);
  setters.setEndDateScheduling(snapshot.endDateScheduling);
  setters.setShowEmployeesTable(snapshot.showEmployeesTable);
  setters.setEmployeesFromTemplate(snapshot.selectedEmployees);
  setters.setIsCollapseTree(false);

  sessionStorage.removeItem(SNAPSHOT_KEY);
  sessionStorage.removeItem(RESTORE_PENDING_KEY);

  return snapshot;
};
